import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sessionOperations", "sessionRadio"]

  connect() {
    console.log('connected to bpf')
    this.updateSessionOperations()
  }

  updateSessionOperations() {
    console.log('updating session operations')
    const checkedRadio = this.sessionRadioTargets.find(radio => radio.checked)
    const currentOp = checkedRadio ? `op-${checkedRadio.value}` : undefined

    // Hide all operation sections
    this.sessionOperationsTarget.querySelectorAll(':scope > div').forEach(div => {
      div.style.display = 'none'
    })

    // Show the selected operation section
    if (currentOp) {
      const targetDiv = this.sessionOperationsTarget.querySelector(`.${currentOp}`)
      if (targetDiv) {
        targetDiv.style.display = 'block'
      }
    }
  }

  handleSubmit(event) {
    // Remove hidden operation divs before form submission
    this.sessionOperationsTarget.querySelectorAll(':scope > div:not([style*="display: block"])').forEach(div => {
      div.remove()
    })
  }
}
